import React from "react"
import StyledLink, { StyledLinkProps } from "../Atoms/StyledLink"
import { useLocation } from "react-router-dom"

interface DetailLinkProps extends Omit<StyledLinkProps, "id" | "to"> {
  /**
   * A unique identifier for the item
   * This is usally the 'id' or 'uuid' field of the data
   */
  id?: string | number
}
const DetailLink = ({ children, id, ...otherProps }: DetailLinkProps) => {
  // Try co-ercing it into a valid integer if not just link to a new item
  const itemId = id && parseInt(id.toString()) ? id : "new"
  const location = useLocation()

  return (
    <StyledLink to={`${location.pathname}/${itemId}`} {...otherProps}>
      {children}
    </StyledLink>
  )
}

export default DetailLink
